import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-[#1B1B20] via-[#1B1B20] to-[#1A73E8]/20 text-white overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 bg-[#1A73E8] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#ED1C24] rounded-full blur-3xl"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-16 md:py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#1A73E8]/20 border border-[#1A73E8]/30 rounded-full px-4 py-2 mb-6">
              <Icon name="Shield" size={16} color="#1A73E8" />
              <span className="text-xs md:text-sm font-medium text-[#1A73E8]">Trusted by Fortune 500 Leaders</span>
            </div>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6 leading-tight">
              Enterprise-Grade Policy Intelligence for Medical Device Leaders
            </h1>
            
            <p className="text-base md:text-lg lg:text-xl text-gray-300 mb-6 md:mb-8 leading-relaxed">
              13 years of proven reliability monitoring critical policy changes for Stryker, Medtronic, Boston Scientific, and industry leaders. Never miss a coverage update that impacts your business.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                variant="default" 
                size="lg"
                iconName="Calendar"
                iconPosition="left"
                className="bg-[#ED1C24] hover:bg-[#ED1C24]/90"
              >
                Schedule Executive Briefing
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                iconName="FileText"
                iconPosition="left"
                className="border-white/30 text-white hover:bg-white/10"
              >
                Download Enterprise Guide
              </Button>
            </div>
            
            <div className="mt-8 md:mt-12 grid grid-cols-3 gap-4 md:gap-6">
              <div>
                <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1A73E8]">13+</div>
                <div className="text-xs md:text-sm text-gray-400 mt-1">Years Proven</div>
              </div>
              <div>
                <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1A73E8]">500K+</div>
                <div className="text-xs md:text-sm text-gray-400 mt-1">Policies Monitored</div>
              </div>
              <div>
                <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1A73E8]">99.9%</div>
                <div className="text-xs md:text-sm text-gray-400 mt-1">Uptime SLA</div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 md:p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-[#ED1C24]/20 rounded-lg flex items-center justify-center">
                  <Icon name="Shield" size={24} color="#ED1C24" />
                </div>
                <div>
                  <div className="text-sm text-gray-400">Real-Time Monitoring</div>
                  <div className="text-lg md:text-xl font-semibold">Active Alerts Dashboard</div>
                </div>
              </div>
              
              <div className="space-y-3">
                {[
                  { status: 'critical', title: 'CMS Coverage Policy Update', time: '2 min ago' },
                  { status: 'warning', title: 'FDA Device Classification Change', time: '15 min ago' },
                  { status: 'info', title: 'State Medicaid Policy Revision', time: '1 hour ago' }
                ]?.map((alert, index) => (
                  <div key={index} className="bg-white/5 border border-white/10 rounded-lg p-4 flex items-start gap-3">
                    <div className={`w-2 h-2 rounded-full mt-2 ${
                      alert?.status === 'critical' ? 'bg-[#ED1C24]' : 
                      alert?.status === 'warning' ? 'bg-[#F59E0B]' : 'bg-[#1A73E8]'
                    }`}></div>
                    <div className="flex-1 min-w-0">
                      <div className="text-sm md:text-base font-medium truncate">{alert?.title}</div>
                      <div className="text-xs text-gray-400 mt-1">{alert?.time}</div>
                    </div>
                    <Icon name="ChevronRight" size={16} color="#9CA3AF" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;